import React, { Component } from 'react';
import { F } from './RestaurantOrderFields';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions/index';
import axios from '../../../axios-url'
import { ORDER_TYPES } from '.././../Layout/POSSidebar';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
class TableSelection extends Component {

    constructor(props) {
        super(props);
        this.state = {
            search: '', filter: 'ALL', now: Date.now(), tables: [],
            // Release-locked-tables modal — select then confirm, rather than a
            // per-card control, so releasing is a deliberate step separate from
            // the grid itself.
            releaseModalOpen: false,
            selectedForRelease: [],
        };
        this._timer = null;
    }

    componentDidMount() {
        
        // this.props.getMasterTableList('res/GetresTableList?companyid=' + this.props.loggedUserDetail.CompanyId);  // --- IGNORE ---
        // Tick every minute to keep elapsed time fresh
        this._timer = setInterval(() => this.setState({ now: Date.now() }), 60000);
    }

    componentWillUnmount() {
        clearInterval(this._timer);
    }

    

    getElapsed(startTime) {
        const diff = this.state.now - startTime;
        const mins = Math.floor(diff / 60000);
        if (mins < 60) return `${mins}m`;
        const hrs = Math.floor(mins / 60);
        const rem = mins % 60;
        return rem > 0 ? `${hrs}h ${rem}m` : `${hrs}h`;
    }

    getStatusLabel(status) {
        if (status === 'running')  return 'Occupied';
        if (status === 'locked')   return 'Locked';
        if (status === 'reserved') return 'Reserved';
        if (status === 'closed')   return 'Closed';
        return 'Available';
    }

    // Table Master (restable) status: 1 = Available, 2 = Occupied, 3 = Locked,
    // 4 = Reserved — see AddTableMaster.js statusOptions. A live browser session
    // (this waiter's own in-progress click) always wins, for instant feedback
    // ahead of the Table Master round-trip; otherwise the backend status is the
    // source of truth. Locked means another user's click claimed this table a
    // moment ago, ahead of any order existing on it yet; Reserved is a manual,
    // admin-set hold (Add/Edit Table) rather than anything this screen sets.
    // A table with a running order (GetrestableOrderNum) is Occupied, whoever
    // opened it — POS, QR or another device — and frees itself when that order
    // closes. Only what that list can't know comes from elsewhere: a draft
    // locked on this device, then the Table Master's own status (Locked /
    // Reserved, or Occupied for an order the list hasn't caught up with).
    resolveTableStatus(table, session, runningOrder) {
        if (runningOrder) return 'running';
        if (session && session.status === 'locked') return 'locked';
        const backendStatus = Number(table.status);
        if (backendStatus === 2) return 'running';
        if (backendStatus === 3) return 'locked';
        if (backendStatus === 4) return 'reserved';
        return 'available';
    }

    // Locked only guards against two people accidentally starting an order on
    // the same table at once — it's not an exclusive claim, so anyone viewing
    // the grid (not just whoever locked it) can release a table stuck this
    // way, e.g. the original click was abandoned before an order was made.
    getLockedTables() {
        const { tableSessions = {}, tables = [], runningOrders = [] } = this.props;
        const busyTables = new Set(runningOrders.map(o => o.tableNumber).filter(Boolean));
        return tables.filter(t =>
            !busyTables.has(t.tableNo) && this.resolveTableStatus(t, tableSessions[t.tableId]) === 'locked'
        );
    }

    handleReleaseSelected = () => {
        const { tables = [] } = this.props;
        const { selectedForRelease } = this.state;
        selectedForRelease.forEach(tableId => {
            const table = tables.find(t => t.tableId === tableId);
            if (table) this.props.onReleaseTable && this.props.onReleaseTable(table);
        });
        this.setState({ releaseModalOpen: false, selectedForRelease: [] });
    };

    toggleReleaseTable = (tableId) => {
        this.setState(prev => ({
            selectedForRelease: prev.selectedForRelease.includes(tableId)
                ? prev.selectedForRelease.filter(id => id !== tableId)
                : [...prev.selectedForRelease, tableId],
        }));
    };

    // render() {
    //     const { search, filter,  } = this.state;
    //     const { tableSessions = {} ,tables =[]} = this.props;

    //     const filtered = tables
    //         .filter(t => t.tableNo.toLowerCase().includes(search.toLowerCase()))
    //         .filter(t => {
    //             const session = tableSessions[t.tableId];
    //             const status = session ? session.status : 'available';
    //             if (filter === 'ALL')       return true;
    //             if (filter === 'AVAILABLE') return status === 'available';
    //             if (filter === 'OCCUPIED')  return status === 'running';
    //             return true;
    //         });

    //     return (
    //         <div className="pos-table-selection">

    //             <div className="pos-table-filters">
    //                 <input
    //                     className="pos-table-search"
    //                     placeholder="Search table"
    //                     value={search}
    //                     onChange={(e) => this.setState({ search: e.target.value })}
    //                 />
    //                 <select
    //                     value={filter}
    //                     onChange={(e) => this.setState({ filter: e.target.value })}
    //                 >
    //                     <option value="ALL">ALL</option>
    //                     <option value="AVAILABLE">Available</option>
    //                     <option value="OCCUPIED">Occupied</option>
    //                 </select>
    //             </div>

    //             <h3 className="pos-table-heading">DINE IN</h3>

    //             <div className="pos-table-grid">
    //                 {filtered.map(table => {
    //                     const session  = tableSessions[table.tableId];
    //                     const status   = session ? session.status : 'available';
    //                     const elapsed  = session && session.status === 'running'
    //                         ? this.getElapsed(session.startTime)
    //                         : null;
    //                     const waiter   = session && session.stageFields && session.stageFields[F.WAITER]
    //                         ? session.stageFields[F.WAITER].FieldValue
    //                         : null;

    //                     return (
    //                         <div
    //                             key={table.tableId}
    //                             className={`pos-table-card pos-table-card--${status}`}
    //                             onClick={() => this.props.onSelectTable(table)}
    //                         >
    //                             <div className="pos-table-card__number">{table.tableNo}</div>

    //                             <div className={`pos-table-card__status pos-table-card__status--${status}`}>
    //                                 {this.getStatusLabel(status)}
    //                             </div>

    //                             {elapsed && (
    //                                 <div className="pos-table-card__elapsed">
    //                                     ⏱ {elapsed}
    //                                 </div>
    //                             )}

    //                             {waiter && (
    //                                 <div className="pos-table-card__waiter">
    //                                     👤 {waiter}
    //                                 </div>
    //                             )}
    //                         </div>
    //                     );
    //                 })}
    //             </div>

    //         </div>
    //     );
    // }

    render() {
    const { search, filter } = this.state;
    const { tableSessions = {}, tables = [], runningOrders = [] } = this.props;

    // Build a quick lookup: tableNumber → running order
    const runningOrderMap = {};
    runningOrders
    // .filter(order => order.orderType === ORDER_TYPES.DINE_IN)
    .forEach(order => {
        if (order.tableNumber) {
            runningOrderMap[order.tableNumber] = order;
        }
    });

    const filtered = tables
        .filter(t => t.tableNo.toLowerCase().includes(search.toLowerCase()))
        .filter(t => {
            const session  = tableSessions[t.tableId];
            const status   = this.resolveTableStatus(t, session, runningOrderMap[t.tableNo]);
            if (filter === 'ALL')       return true;
            if (filter === 'AVAILABLE') return status === 'available';
            if (filter === 'OCCUPIED')  return status === 'running';
            return true;
        });

    const lockedTables = this.getLockedTables();

    return (
        <div className="pos-table-selection">
            <div className="pos-table-filters">
                <input
                    className="pos-table-search"
                    placeholder="Search table"
                    value={search}
                    onChange={(e) => this.setState({ search: e.target.value })}
                />
                <select
                    value={filter}
                    onChange={(e) => this.setState({ filter: e.target.value })}
                >
                    <option value="ALL">ALL</option>
                    <option value="AVAILABLE">Available</option>
                    <option value="OCCUPIED">Occupied</option>
                </select>
                {lockedTables.length > 0 && (
                    <Button
                        label={`Release Locked (${lockedTables.length})`}
                        icon="pi pi-lock-open"
                        className="pos-release-btn p-button-outlined p-button-sm"
                        onClick={() => this.setState({ releaseModalOpen: true, selectedForRelease: [] })}
                    />
                )}
            </div>

            <Dialog
                header="Release Locked Tables"
                visible={this.state.releaseModalOpen}
                onHide={() => this.setState({ releaseModalOpen: false, selectedForRelease: [] })}
                className="pos-info-dialog pos-release-dialog"
                style={{ width: '380px' }}
                dismissableMask
                footer={
                    <div className="pos-modal-actions">
                        <Button
                            label="Cancel"
                            className="p-button-outlined"
                            onClick={() => this.setState({ releaseModalOpen: false, selectedForRelease: [] })}
                        />
                        <Button
                            label="Release"
                            className="p-button-primary"
                            disabled={this.state.selectedForRelease.length === 0}
                            onClick={this.handleReleaseSelected}
                        />
                    </div>
                }
            >
                <p className="pos-field-label">
                    Tables stuck Locked (claimed but never opened into an order).
                    Check the ones to send back to Available.
                </p>
                <div className="pos-release-list">
                    <div
                        className="pos-release-row pos-release-row--all"
                        onClick={() => this.setState({
                            selectedForRelease: this.state.selectedForRelease.length === lockedTables.length
                                ? []
                                : lockedTables.map(t => t.tableId),
                        })}
                    >
                        <Checkbox
                            checked={lockedTables.length > 0 && this.state.selectedForRelease.length === lockedTables.length}
                            onChange={() => {}}
                        />
                        <span className="pos-release-row__label">Select all ({lockedTables.length})</span>
                    </div>
                    {lockedTables.map(t => (
                        <div
                            key={t.tableId}
                            className="pos-release-row"
                            onClick={() => this.toggleReleaseTable(t.tableId)}
                        >
                            <Checkbox
                                checked={this.state.selectedForRelease.includes(t.tableId)}
                                onChange={() => {}}
                            />
                            <span className="pos-release-row__label">{t.tableNo}</span>
                            <span className="pos-table-card__status pos-table-card__status--locked">Locked</span>
                        </div>
                    ))}
                </div>
            </Dialog>

            <h3 className="pos-table-heading">DINE IN</h3>

            <div className="pos-table-grid">
                {filtered.map(table => {
                    const session       = tableSessions[table.tableId];
                    const runningOrder  = runningOrderMap[table.tableNo];
                    const status        = this.resolveTableStatus(table, session, runningOrder);

                    const orderNo = runningOrder?.ordereNumber || null;

                    // Blocked to THIS browser only when the table isn't available,
                    // nobody here has it open already (session), and there's no
                    // running order to jump into — i.e. someone else's click just
                    // locked/occupied it. A table with a runningOrder stays
                    // clickable so a different staff member can still open/continue
                    // that order (billing, etc.). handleTableSelect re-checks the
                    // live status before actually locking, so this is an instant
                    // local guard, not the authoritative one.
                    const blocked = status !== 'available' && !session && !runningOrder;

                   // In TableSelection render(), replace the card JSX:
            return (
                <div
                    key={table.tableId}
                    className={`pos-table-card pos-table-card--${status}${blocked ? ' pos-table-card--blocked' : ''}`}
                    onClick={() => { if (!blocked) this.props.onSelectTable(table, runningOrder); }}
                >
                    <div className="pos-table-card__number">{table.tableNo}</div>

                    <div className={`pos-table-card__status pos-table-card__status--${status}`}>
                        {this.getStatusLabel(status)}
                    </div>

                    {/* Duration, order number and amount all come from the running-orders API only */}
                    {runningOrder?.duration && (
                        <div className="pos-table-card__elapsed">
                            ⏱ {runningOrder.duration}
                        </div>
                    )}

                    {runningOrder?.ordereNumber && (
                        <div className="pos-table-card__order">
                            🧾 {runningOrder.ordereNumber}
                        </div>
                                )}

                                {runningOrder?.amount && (
                                    <div className="pos-table-card__amount">
                                        💰 {runningOrder.amount}
                                    </div>
                                )}
                            </div>
                        );
                })}
            </div>
        </div>
    );
}
}
const mapStateToProps = state => {
    return {
        error: state.master.error,
        loading: state.master.loading,
        success: state.master.success,
        loggedUserDetail: state.auth.userObject,
        tables: state.master.masterData.GetresTableList,
        // tableLists: (state.master.tableLists !== undefined && state.master.tableLists !== null) ? state.master.tableLists : [],
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        clearCacheStorage: (type, data) => dispatch(actions.clearCacheStorage(type, data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps) (TableSelection);